<app-loading [showText]="false" *ngIf="loading"></app-loading>
<mat-form-field [formGroup]="parentFormGroup" [style]="loading ? 'display: none !important;' : ''"
                appearance="outline"
                subscriptSizing="dynamic">
    <mat-select [formControlName]="parentFormControlName"
                #matSelect [placeholder]="placeHolderLabel"
                [multiple]="true"
                (selectionChange)="onSelectionChanged($event)"
                (focus)="focussed()">
        <mat-select-trigger>
            <span *ngFor="let selectedElement of getSelectedElements(); let isFirst = first">
                <span *ngIf="!isFirst">  -  </span>
                <ng-container [ngTemplateOutlet]="template || defaultContentTpl" [ngTemplateOutletContext]="{element:selectedElement}"></ng-container>
            </span>
        </mat-select-trigger>

        <mat-option>
            <ngx-mat-select-search
                    [showToggleAllCheckbox]="true"
                    (toggleAll)="toggleSelectAll($event)"
                    toggleAllCheckboxTooltipMessage="Sélectionner/désélectionner tous les éléments"
                    [toggleAllCheckboxIndeterminate]="elementControl.value?.length > 0 && elementControl.value?.length < list?.length"
                    [toggleAllCheckboxChecked]="elementControl.value?.length === list?.length"
                    [noEntriesFoundLabel]="noEntriesFoundLabel"
                    placeholderLabel="Filtrer..."
                    [formControl]="filterCtrl"
            ></ngx-mat-select-search>
        </mat-option>
        <mat-option disabled="true" class="new-item" *ngIf="newItemModalOptions" (click)="newItemSelected(newItemModalOptions)">
            <span>
                <mat-icon>add_circle_outline</mat-icon><span>Créer</span>
            </span>
        </mat-option>
        <mat-option *ngFor="let selectFilterElement of filteredElements | async" [value]="selectFilterElement.value" [id]="selectFilterElement.id">
            <ng-container [ngTemplateOutlet]="template || defaultContentTpl" [ngTemplateOutletContext]="{element:selectFilterElement.element}"></ng-container>
        </mat-option>
    </mat-select>
</mat-form-field>

<ng-template #defaultContentTpl let-element='element'>
    <span [innerHTML]="element | keepHtml"></span>
</ng-template>
